import { cx } from '@linaria/core';
import { HTMLAttributes, ReactNode } from 'react';
import "./FlexGrid.linaria.module.css!=!./FlexGrid?./FlexGrid.linaria.module.css?css=H4sIAAAAAAAAA12L4QrCIBRG//cujYQYzR5G3J2J5Lx2Z2qNvfuQCsw/Hxy+czoZZjEsgoWcTLTrZBZv5YvfrMrX7dCVW5Jgoz/jHRpci3WcDCkIBh0HtM/ZVVmkCCr/UxsRpl8xKsH05aT7vsFPk0h6Xqb2HwOAfjdY+Q6/xQ4nW9ek6gAAAA=="
interface GridProps extends HTMLAttributes<HTMLDivElement> {
  direction?: 'column' | 'row';
  wrap?: 'wrap' | 'nowrap';
  children: ReactNode;
  className?: string;
  style?: any;
  ref?: any;
}
const basicGridStyles = "atm_9s_1txwivl";
const gridColumn = "atm_ar_1bp4okc";
const gridRow = "atm_ar_vrvcex";
const gridWrap = "atm_be_1g80g66";
const gridNoWrap = "atm_be_1q9ccgz";
const FlexGrid = (props: GridProps) => {
  const {
    direction = 'column',
    wrap = 'nowrap',
    children,
    className,
    ...rest
  } = props;
  return <div {...rest} className={cx(basicGridStyles, direction === 'column' ? gridColumn : gridRow, wrap === 'nowrap' ? gridNoWrap : gridWrap, className)}>
            {children}
        </div>;
};
export default FlexGrid;